
export function reportType() {
  let isJs = false
  const reportType = localStorage.getItem('reportType')
  try {
    // 判断是否是江苏上报
    if (reportType === '3') {
      isJs = true
    }
  } catch (e) {
    // rww
  }
  return isJs
}
export function reportTypeGuangdong() {
  let isGd = false
  const reportType = localStorage.getItem('reportType')
  try {
    // 判断是否是江苏上报
    if (reportType === '13') {
      isGd = true
    }
  } catch (e) {
    // rww
  }
  return isGd
}
